import * as React from "react";
import type { SVGProps } from "react";
const SvgKtvAreaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="ktv_area_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M806.272 163.925a42.667 42.667 0 0 1 64.256 56.192l-134.4 153.6A42.667 42.667 0 0 1 704 388.267h-96L467.072 546.73a42.667 42.667 0 0 1-59.179 4.437l-85.333-71.04-126.037 126.037a42.667 42.667 0 0 1-60.331-60.33l153.6-153.6a42.667 42.667 0 0 1 57.472-2.603l83.456 69.547 126.165-141.91a42.667 42.667 0 0 1 31.915-14.336h95.83l121.642-139.008zm18.432 167.296a42.667 42.667 0 0 1 75.563 27.179v460.8a42.667 42.667 0 0 1-42.667 42.667H166.4a42.667 42.667 0 0 1-42.667-42.667v-80.64a42.667 42.667 0 0 1 14.422-32l167.594-147.84a42.667 42.667 0 0 1 58.496 1.963l74.454 75.05 179.157-180.65a42.667 42.667 0 0 1 30.293-12.63H732.8l91.904-111.232zm-9.77 145.792L785.748 512.3a42.667 42.667 0 0 1-32.853 15.488h-1.28l63.317 74.24V477.013zM605.78 588.416l151.851 188.16h57.301v-43.179L651.648 542.165l-45.867 46.251zM499.627 695.509l64.341 77.184a47.072 47.072 0 0 1 2.859 3.84h81.152L545.323 649.387l-45.654 46.08zm-203.819-14.208 76.16 91.392c1.067 1.238 2.005 2.56 2.859 3.84h81.28l-34.134-40.96a42.667 42.667 0 0 1-13.568-9.216l-76.373-77.013-36.224 31.957zm-86.741 76.459v18.773h55.04l-32.299-38.826-22.741 20.053z"
    />
  </svg>
);
export default SvgKtvAreaIcon;
